"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundListRequest = void 0;
var FundListRequest = /** @class */ (function () {
    function FundListRequest() {
    }
    return FundListRequest;
}());
exports.FundListRequest = FundListRequest;
;
//# sourceMappingURL=fundList.request.js.map